export const environment = {
  production: true,
  ENVIRONMENT: {
    NOMBRE_SISTEMA: 'FIDELIS',
    DESCRIPCION_SISTEMA: 'Sistema de Votación por Internet',
    VERSION: '3.0.0',
    AMBIENTE: 'Produccion',
    PROTOCOLO: 'https',
    SALT: '0db67866-68fb-4fd4-b58f-de28e48aa4c6',
    MOSTRAR_COMPONENTES_INICIO: false,
    NIVELES_MAXIMOS_CODIFICACION_VOTOS_BLOQUE: 3,
    INACTIVITY_MINUTES: 15
  },
  REST_API: {
    URL: '@PROTOCOLO://fidelis.cs.cinvestav.mx/fidelis/api/v1/',
    URL_REPORTES: '@PROTOCOLO://fidelis.cs.cinvestav.mx/fidelis/apiexcel/v1/report/',
    URL_FILES: '@PROTOCOLO://fidelis.cs.cinvestav.mx/fidelis/apifile/v1/file/',
    AUTH_TYPE: 'Basic',
    AUTH_USERNAME: '1047635f43dd75a0b91207ae4ad5fbb8',
    AUTH_PASSWORD: '185ee08a37b00858cf9dbbcfc01a8a69',
    PAGINADO_URL_REEMPLAZAR: 'http://fidelis.cs.cinvestav.mx/fidelis/api/v1/',
    PAGINADO_URL_REEMPLAZO: 'https://fidelis.cs.cinvestav.mx/fidelis/api/v1/'
  }
};
